module.exports = __webpack_public_path__ + "img/GroupBot-Logo-Light.0eb14c16.png";